module.exports = __webpack_public_path__ + "img/jiaot5.89ef507a.png";